import {
  Configuration,
  BusinessPartnerApi,
  RequestApi,
  UserApi,
} from "@socotec.io/apollo-sync-back-sdk";
import { getFreshAccessToken } from "./getAccessToken.js";

const configuration = new Configuration({
  basePath: import.meta.env.VITE_APP_BACK_URL,
  accessToken: () => getFreshAccessToken(),
});

export const businessPartnerApi = new BusinessPartnerApi(configuration);
export const userApi = new UserApi(configuration);
export const requestApi = new RequestApi(configuration);
